import React, { useEffect, useMemo, useState } from 'react';

const normalizeMonth = (value) => {
  if (typeof value !== 'string') return '';
  const match = value.match(/^(\d{4})-(\d{2})$/);
  return match ? `${match[1]}-${match[2]}` : '';
};

const supportMonthInput = () => {
  if (typeof document === 'undefined') return true;
  const i = document.createElement('input');
  i.setAttribute('type', 'month');
  return i.type === 'month';
};

const MonthInput = ({ value, onChange, className = '', onFocus, placeholder = 'AAAA-MM', forceFallback = false }) => {
  const supportsMonth = useMemo(supportMonthInput, []);
  const val = normalizeMonth(value);

  // Local state for fallback (declare hooks unconditionally to satisfy rules-of-hooks)
  const [year, setYear] = useState(val ? val.split('-')[0] : '');
  const [month, setMonth] = useState(val ? val.split('-')[1] : '');

  // Sync local state when external value changes (safe even if not used in native path)
  useEffect(() => {
    const [y, m] = val ? val.split('-') : ['', ''];
    setYear(y || '');
    setMonth(m || '');
  }, [val]);

  const updateMonth = (m) => {
    setMonth(m);
    if (year && m) onChange(`${year}-${m}`);
  };

  const updateYear = (y) => {
    setYear(y);
    if (y && month) onChange(`${y}-${month}`);
  };

  if (supportsMonth && !forceFallback) {
    return (
      <input
        type="month"
        value={val}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        className={className}
        placeholder={placeholder}
      />
    );
  }

  return (
    <div className="flex items-center gap-2">
      <select
        value={month}
        onChange={(e) => updateMonth(e.target.value)}
        className={`px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
      >
        <option value="">MM</option>
        {Array.from({ length: 12 }).map((_, idx) => {
          const m = String(idx + 1).padStart(2, '0');
          return (
            <option key={m} value={m}>{m}</option>
          );
        })}
      </select>
      <input
        type="number"
        inputMode="numeric"
        min={1900}
        max={2100}
        value={year}
        onChange={(e) => updateYear(e.target.value)}
        className={`w-24 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
        placeholder="AAAA"
      />
    </div>
  );
};

export default MonthInput;

